import React, { useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";

const EnergoTooltip = ({text, position, color, style}) => {

    const textColor = color? color : "text-energo";

    const [show, setShow] = useState(false);
    const target = useRef(null);

    return (
        <>
            <div ref={target}><FaInfoCircle style={style} className={textColor} onClick={() => setShow(!show)} /></div>
            <Overlay target={target.current} show={show} placement={position} 
                rootClose={true} rootCloseEvent="click" onHide={() => setShow(false)}>
                {(props) => (
                    <Tooltip id="overlay" {...props}>
                        {text}
                    </Tooltip>
                )}
            </Overlay>
        </>
    )
}
export default EnergoTooltip;